import { RootState } from 'editor/src/store/index';

import getSessionImages from './getSessionImages';

const getGalleryImagesSizeSum = (state: RootState) =>
  getSessionImages(state).reduce((acc, image) => acc + (image.bytesTotal || 0), 0);

export default getGalleryImagesSizeSum;
